module.exports = __webpack_public_path__ + "img/widget.07be8e39.svg";